import { getViewStorage } from "./viewStorage.js";
import forge from "node-forge";
import Handlebars from 'handlebars';
import { getView } from './helper';
import { getToken } from './helper';

export var M = "";
export const K = "WjGJYzSUN9jvIy24O2nNZzVHEyCrpzczH0DV2xiXphB";

// Inistail state of the config.
export const initialState = {
    acls: [],
    acl_fields: [],
    view: {
        sort: { field: "cm_modified", direction: "desc" },
        query: "",
        facets: ["path_starts_with"],
        columns: ["cm_name", "cm_title", "cm_modified"],
        filters: [],
        results_view: "grid",
        filter_rules: [],
    },
    summary_views: [],
    result_views: [],
    colour_rules: [],
    social_media: {
        facebook_filters: [],
        instagram_filters: []
    },
    media: { allow_social: false },
    title: "SchoolBench®",
    default_filter: "",
    filter_rules: {},
    path_strip: "/Company Home/",
    drop_folder: "/Company Home/Semabench",
    loaded: false,
    failed: false,
    suggested_searches: [],
    pipeline_names: {},
    has_watermark: false,
    enable_quick_parent: false,
    enable_community: false,
    enable_timeout: "false",
    action_timeout: "10",
    popup_timeout: "30"
};

export var config = initialState;

export const descriptionPlaceholder = () => {
    try {
        return "Please enter a description";
    } catch (err) {
        console.error("[descriptionPlaceholder] error:", err, "config:", config);
        return "Enter a description";
    }
};

// initial state of the info and default fields
const infoInitialState = {
    fields: {
        "path_starts_with": {
            title: "Path Starts With",
            type: "path",
            is_mandatory: false,
            is_multivalued: false
        },
        "type": {
            title: "Type",
            type: "text",
            is_mandatory: false,
            is_multivalued: false
        },
        "mime_type": {
            title: "Mime type",
            type: "text",
            is_mandatory: false,
            is_multivalued: false
        },
        "size": {
            title: "File size",
            type: "long",
            is_mandatory: false,
            is_multivalued: false
        },
        "preview_kind": {
            title: "Preview Kind",
            type: "text",
            is_mandatory: false,
            is_multivalued: true
        },
        "id": {
            title: "Node ID",
            type: "text",
            is_mandatory: false,
            is_multivalued: false
        }
    },
    // for provide the corresponding labels for fields name coming back from solr or Alfresco
    lookup: { "sb_class": "Classification", "preview_kind": "Preview Kind", "path": "Path", "path_starts_with": "Path Starts With", "type": "Type", "size": "File size", "mime_type": "Mime type", "aspects": "Aspects", "site": "Site", "id": "Node ID", "[NOW-1DAY TO NOW]": "Last 24hrs", "[NOW-7DAYS TO NOW]": "Last 7 days", "[NOW-1MONTH TO NOW]": "Last 31 days", "[NOW-1YEAR TO NOW]": "Last 365 days", "[* TO NOW-1YEAR]": "More than a year ago" },
    error: {}
};


export var Field_Info = infoInitialState;

/**
 * Take a config and augment with any default values or adjustments that need to be made before
 * loading in the config
 */
const populateDefaultValues = (config) => {

    if (config.view.filter_rules === undefined || config.view.filter_rules === null) {
        config.view.filter_rules = populateFilterRules(config);
    }

    // Populate any missing keys from initialState (eg. user has upgraded and is missing a view key)
    Object.keys(initialState.view).forEach(key => {
        if (config.view[key] === undefined || config.view[key] === null) {
            config.view[key] = initialState[key];
        }
    });

    return config;
}

// populates the default filter rules if undefined
const populateFilterRules = (config) => {
    if (config.filter_rules !== undefined && config.filter_rules !== null) {
        return Object.keys(config.filter_rules);
    }
    return [];
}

// Loads the config from the server
export async function loadConfig() {
    let response = await fetch("../api/v1/config", {
        mode: 'no-cors',
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    });

    let resp = await response.json();
    config = resp.config;
    config.portal_valid = resp.portal_valid
    config.sbdrive = resp.sbdrive
    config.view.filter_rules = populateFilterRules(config);
    config = populateDefaultValues(config);
    let acls = [];
    let acl_fields = [];

    if (resp.acl !== undefined && resp.acl !== null) {
        acls = resp.acl.map(acl => {
            acls.roles = acl.roles.map(role => {
                let transformedRole = role;

                if (typeof role === 'string') {
                    let re = /{{[{]?(.*?)[}]?}}/g;
                    let match = null;
                    let is_template = false;

                    while ((match = re.exec(role))) {
                        is_template = true;
                        acl_fields.push(match[1]);
                    }

                    if (is_template) {
                        transformedRole = Handlebars.compile(role);
                    }
                }
                return transformedRole;
            });

            if (acl.params && acl.params.matched_values) {
                Object.keys(acl.params.matched_values).forEach(val => acl_fields.push(val));
            }
            return acl;
        });

        config.acls = acls;
        config.acl_fields = acl_fields;
    }

    let view = JSON.parse(getViewStorage().getItem("V"));
    if (view === null || view === undefined) {
        getViewStorage().setItem("V", JSON.stringify(config.view));
    }

    loadInfo(resp.fields);
}


// Loads the config from the server
export function updateConfig(new_config) {
    config = new_config
}

function loadInfo(field_info) {
    if (field_info !== undefined && field_info !== null) {
        let lookup = Field_Info.lookup;
        let fields = field_info;

        if (fields["cm_content"]) {
            fields["cm_content"].is_multivalued = true;
        }

        Object.keys(fields).forEach((key) => {
            if (fields[key].title) {
                lookup[key] = fields[key].title;
            }
        });

        Field_Info.fields = {
            ...Field_Info.fields,
            ...fields
        }
        Field_Info.lookup = lookup;
    }

}

// Method called to get the form from the local storage
export const getForm = () => {
    let form = {
        "rulesets": [
            {
                "name": "default_node",
                "conditions": {
                    "required_fields": ["cm_content"],
                    "create_mode": true,
                    "initial_only": true
                },
                "templates": {
                    "path": "/Company Home/Schoolbench/{{substring id 0 2}}/{{substring id 2 4}}/",
                    "sb_adminStatus": "Unverified",
                    "type": "cm_content",
                    "cm_name": "{{{filename}}}"
                }
            },
            {
                "name": "profile",
                "conditions": {
                    "required_fields": ["sb_profileName"],
                    "create_mode": true,
                },
                "templates": {
                    "sb_adminStatus": "Profile"
                }
            }
        ]
    }
    return form;
}

export async function LT() {
    return getToken();
}

export async function T() {
    return getToken();
}

export async function DT(encryptedInput, passphrase) {
    const encoder = new TextEncoder();
    const decoder = new TextDecoder();

    function normalizeBase64(b64) {
        return b64.replace(/-/g, '+').replace(/_/g, '/');
    }

    function stripJsonQuotes(s) {
        if (s.length >= 2 && s[0] === '"' && s[s.length - 1] === '"') {
            try {
                return JSON.parse(s);
            } catch {
                // fallback
            }
        }
        return s;
    }

    let rawInput = stripJsonQuotes(String(encryptedInput).trim());
    rawInput = normalizeBase64(rawInput);

    // Decode encrypted input and split nonce + ciphertext + tag.
    const encryptedBytes = Uint8Array.from(atob(rawInput), c => c.charCodeAt(0));
    if (encryptedBytes.length < 12 + 16) {
        throw new Error('Encrypted input too short (must include nonce + tag).');
    }

    const hasSubtleCrypto = typeof window !== 'undefined'
        && window.crypto
        && window.crypto.subtle
        && typeof window.crypto.subtle.decrypt === 'function';

    if (hasSubtleCrypto) {
        // Derive AES key by SHA-256 hashing the passphrase.
        const passphraseBytes = encoder.encode(passphrase);
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', passphraseBytes);
        const secretKeyBytes = new Uint8Array(hashBuffer);

        if (secretKeyBytes.length !== 32) {
            throw new Error('Derived key must be 256 bits (32 bytes) long.');
        }

        const key = await window.crypto.subtle.importKey(
            'raw',
            secretKeyBytes,
            { name: 'AES-GCM' },
            false,
            ['decrypt']
        );

        const nonce = encryptedBytes.slice(0, 12);
        const ciphertext = encryptedBytes.slice(12);
        const ad = encoder.encode('semabench');

        const decrypted = await window.crypto.subtle.decrypt(
            {
                name: 'AES-GCM',
                iv: nonce,
                additionalData: ad,
                tagLength: 128,
            },
            key,
            ciphertext
        );

        let decryptedText = decoder.decode(decrypted);
        decryptedText = decryptedText.replace(/[\0]+$/g, '');
        return decryptedText;
    }

    // Fallback for insecure HTTP origins where window.crypto.subtle is unavailable.
    const md = forge.md.sha256.create();
    md.update(passphrase, 'utf8');
    const keyBytes = md.digest().getBytes();

    if (keyBytes.length !== 32) {
        throw new Error('Derived key must be 256 bits (32 bytes) long.');
    }

    const encryptedBinary = forge.util.decode64(rawInput);
    const nonce = encryptedBinary.slice(0, 12);
    const ciphertext = encryptedBinary.slice(12, -16);
    const tag = encryptedBinary.slice(-16);

    const decipher = forge.cipher.createDecipher('AES-GCM', keyBytes);
    decipher.start({
        iv: nonce,
        additionalData: forge.util.createBuffer('semabench', 'utf8'),
        tagLength: 128,
        tag: forge.util.createBuffer(tag)
    });
    decipher.update(forge.util.createBuffer(ciphertext));

    if (!decipher.finish()) {
        throw new Error('Forge AES-GCM decryption failed.');
    }

    let decryptedText = decipher.output.toString('utf8');
    decryptedText = decryptedText.replace(/[\0]+$/g, '');
    return decryptedText;
}

export const checkFacetList = (facetToCheck) => {
    const localStorageData = JSON.parse(getViewStorage().getItem("V"));
    let facet = [];
    if (localStorageData) {
        facet = localStorageData.facets || [];
    }
    return facet.includes(facetToCheck);
}

export const DefaultFilterList = [
    { label: "Classification", value: "sb_class" },
    { label: "Year", value: "sb_year" },
    { label: "Event", value: "sb_event" },
    { label: "Tags", value: "sb_tags" },
    { label: "Student", value: "sb_student" },
    { label: "Staff", value: "sb_staff" },
    { label: "Past Student", value: "sb_pastStudent" },
    { label: "Year Level", value: "sb_studentYearLevel" },
    { label: "Consent", value: "sb_parentPermissions" },
    { label: "Allowed To Publish", value: "sb_allowedTo" },
    { label: "File Format", value: "mime_type" },
    { label: "Taken Date", value: "exif_dateTimeOriginal" },
    { label: "Boarder", value: "sb_studentBoarder" },
    { label: "Student Campus", value: "sb_studentCampus" },
    { label: "Cohort", value: "sb_studentCohort" },
    { label: "House", value: "sb_studentHouse" },
    { label: "SubSchool", value: "sb_studentSubSchool" },
    { label: "Visitor", value: "sb_visitor" },
    { label: "Published History", value: "sb_publishedTo" },
    { label: "Rendition", value: "preview_kind" },
    { label: "Other Names", value: "sb_otherNames" },
    { label: "Admin Status", value: "sb_adminStatus" },

    ...(checkFacetList("sb_uploaderCampus") ? [{ label: 'Uploader Campus', value: 'sb_uploaderCampus' }] : []),
    { label: 'Week', value: 'sb_week' },
    { label: 'Term', value: 'sb_term' },
    { label: 'Upload Date', value: 'cm_created' }
];

export const FilterNameChanges = {
    'sb_studentBoarder': 'Boarder',
    'sb_studentCampus': 'Student Campus',
    'sb_studentCohort': 'Cohort',
    'sb_studentHouse': 'House',
    'sb_studentSubSchool': 'SubSchool',
    'sb_publishedTo': 'Published History',
    'sb_studentYearLevel': 'Year Level',
    'sb_parentPermissions': 'Consent',
    'preview_kind': 'Rendition',
    'mime_type': 'File Format',
    'sb_uploaderCampus': 'Uploader Campus',
    'sb_adminStatus': 'Admin Status',
    'sb_class': 'Classification'
};

export const ArchivedFilters = [
    { label: 'Boarder', value: 'sb_studentBoarder' },
    { label: 'Student Campus', value: 'sb_studentCampus' },
    { label: 'Cohort', value: 'sb_studentCohort' },
    { label: 'House', value: 'sb_studentHouse' },
    { label: 'SubSchool', value: 'sb_studentSubSchool' },
    { label: 'Visitor', value: 'sb_visitor' },
    { label: 'Published History', value: 'sb_publishedTo' },
    { label: 'Rendition', value: 'preview_kind' },
    { label: 'Other Names', value: 'sb_otherNames' },
    ...(checkFacetList("sb_uploaderCampus") ? [{ label: 'Uploader Campus', value: 'sb_uploaderCampus' }] : []),
    { label: 'Week', value: 'sb_week' },
    { label: 'Term', value: 'sb_term' },
    { label: 'Upload Date', value: 'cm_created' },
    { label: 'Admin Status', value: 'sb_adminStatus' },

];

export const extendColumnsWithLabel = () => {
    const localStorageData = getView();
    let columns = localStorageData?.columns || [];

    const unchangedColumnFields = columns.map(column => ({ label: Field_Info["lookup"][column], value: column }));

    const transformedColumns = unchangedColumnFields.map(option => {
        if (FilterNameChanges[option.value]) {
            return {
                ...option,
                label: FilterNameChanges[option.value]
            };
        }
        return option;
    });
    return transformedColumns;
};

export const saveViewType = (view_type) => {
    const localStorageData = getView();

    let parsedData;
    if (localStorageData) {
        parsedData = localStorageData;
    } else {
        parsedData = {};
    }

    parsedData.view_type = view_type;

    const updatedLocalStorageDataString = JSON.stringify(parsedData);

    getViewStorage().setItem('V', updatedLocalStorageDataString);
};

export const getViewType = () => {
    const localStorageData = getView();
    if (localStorageData) {
        return localStorageData.view_type || 'default';
    }
    return 'default';
};

export const saveFilterValues = () => {
    const localStorageData = getView();

    let parsedData;
    if (localStorageData) {
        parsedData = localStorageData;
    } else {
        parsedData = {};
    }

    const currentFilters = parsedData.filters;

    parsedData.persisted_filters = currentFilters;

    const updatedLocalStorageDataString = JSON.stringify(parsedData);

    getViewStorage().setItem('V', updatedLocalStorageDataString);
};

export const loadFilterValues = () => {
    const localStorageData = getView();
    if (localStorageData) {
        return localStorageData.persisted_filters || [];
    }
    return [];
};

export const getPersistedFilterValue = (filterName) => {
    const localStorageData = getView();
    if (localStorageData) {
        const persistedFilters = localStorageData.persisted_filters || [];

        // Find the specific filter based on the field_name
        const filter = persistedFilters.find(
            item => item.field_name === filterName
        );

        if (filter) {
            return filter.value;
        }
    }
    return null;
};

export const checkAvailableConsent = (nodes, consent_to_check) => {
    if (!nodes) {
        return false;
    }

    const available_consents = nodes.find(node => node.field_name === 'sb_parentPermissions');

    if (available_consents && Array.isArray(available_consents.childNodes)) {
        return available_consents.childNodes.some(childNode => childNode.label === consent_to_check);
    }

    return false;
}
